import { useAuth } from '../../contexts/AuthContext';
import { useOrganization } from '../../contexts/OrganizationContext';
import styles from './Home.module.scss';
import { Layout } from '../../components/layout/Layout';
import PropTypes from 'prop-types';
import { usePreloadDynamicPropertyTypes, useOrganizationDynamicProperties } from '../../api/hooks';

// Flag to show/hide the welcome section (set to true to re-enable)
const SHOW_WELCOME_SECTION = false;

export default function Home({ children }) {
  const { user } = useAuth();
  const { selectedOrganization } = useOrganization();

  // Preload dynamic property types when entering this route
  const { data: dynamicPropertyTypes } = usePreloadDynamicPropertyTypes();

  // Get organization dynamic properties for the current organization
  const { data: organizationDynamicProperties } = useOrganizationDynamicProperties(
    selectedOrganization?.id || '',
    { enabled: !!selectedOrganization?.id }
  );

  // Get dynamic subtitle from organization properties or fallback to default
  const getDynamicSubtitle = () => {
    // First, try to find the property in organization dynamic properties
    if (organizationDynamicProperties?.data) {
      const subtitleProperty = organizationDynamicProperties.data.find(
        prop => prop.propertyTypeName === 'main_section_subtitle'
      );
      
      if (subtitleProperty?.value) {
        return subtitleProperty.value;
      }
    }
    
    // Fallback: get default value from dynamic property types cache
    if (dynamicPropertyTypes?.data) {
      const subtitleType = dynamicPropertyTypes.data.find(
        type => type.name === 'main_section_subtitle'
      );
      
      if (subtitleType?.defaultValue) {
        return subtitleType.defaultValue;
      }
    }
    
    // Final fallback: hardcoded subtitle
    return 'Bienvenido a Papo';
  };

  return (
    <Layout>
      <div className={styles.homeContainer}>
        {SHOW_WELCOME_SECTION && (
          <section className={styles.welcomeSection}>
            <h1>{getDynamicSubtitle()}</h1>
          </section>
        )}
        {children}
      </div>
    </Layout>
  );
}

Home.propTypes = {
  children: PropTypes.node.isRequired,
};